webpackJsonp([79531971968955],{

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Headphones (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n  .headphones {\n    fill: #000000;\n  }\n"),React.createElement("path",{"className":"headphones","fill":"#000000","d":"M4.5 9h-1v7h1c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5z","key":1}),React.createElement("path",{"className":"headphones","fill":"#000000","d":"M11.5 9c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h1v-7h-1z","key":2}),React.createElement("path",{"className":"headphones","fill":"#000000","d":"M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 0.96 0.169 1.88 0.479 2.732-0.304 0.519-0.479 1.123-0.479 1.768 0 1.763 1.304 3.222 3 3.464v-6.928c-0.499 0.071-0.963 0.248-1.371 0.506-0.084-0.417-0.129-0.849-0.129-1.292 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 0.442-0.044 0.874-0.128 1.292-0.408-0.259-0.873-0.435-1.372-0.507v6.929c1.696-0.243 3-1.701 3-3.464 0-0.645-0.175-1.249-0.479-1.768 0.31-0.853 0.479-1.773 0.479-2.732z","key":3})]);
	}
	
	Headphones.defaultProps = {"version":"1.1","width":"16","height":"16","viewBox":"0 0 16 16"};
	
	module.exports = Headphones;
	
	Headphones.default = Headphones;


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.devotionalPageQuery = exports.DevotionalPageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Page = __webpack_require__(31);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _headphones = __webpack_require__(397);
	
	var _headphones2 = _interopRequireDefault(_headphones);
	
	var _devotionalModule = __webpack_require__(330);
	
	var _devotionalModule2 = _interopRequireDefault(_devotionalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ESV_API_URL = 'https://api.esv.org/v3/passage/';
	var ESV_AUDIO_URL = 'https://audio.esv.org/hw/';
	var ESV_API_KEY = ("7c583859be1da65dffd0cfe7bcc5535514156b85");
	var DAY = 60 * 60 * 24 * 1000;
	
	var SkeletonElement = function SkeletonElement(_ref) {
	  var children = _ref.children,
	      type = _ref.type,
	      rest = _objectWithoutProperties(_ref, ['children', 'type']);
	
	  return _react2.default.createElement(type, _extends({}, rest), children);
	};
	
	var SkeletonScreen = function SkeletonScreen() {
	  return _react2.default.createElement(
	    'article',
	    { className: _devotionalModule2.default.article },
	    _react2.default.createElement(
	      'div',
	      { className: _devotionalModule2.default.titleWrapper },
	      _react2.default.createElement(SkeletonElement, { className: '' + _devotionalModule2.default.articleTitleSkeleton, type: 'h2' })
	    ),
	    _react2.default.createElement(SkeletonElement, {
	      className: _devotionalModule2.default.paragraphSkeleton + ' ' + _devotionalModule2.default.date,
	      type: 'p'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _devotionalModule2.default.articleContent },
	      _react2.default.createElement(SkeletonElement, { className: '' + _devotionalModule2.default.subTitleSkeleton, type: 'h3' }),
	      _react2.default.createElement(SkeletonElement, {
	        className: _devotionalModule2.default.paragraphSkeleton + ' ' + _devotionalModule2.default.long,
	        type: 'p'
	      }),
	      _react2.default.createElement(SkeletonElement, {
	        className: _devotionalModule2.default.paragraphSkeleton + ' ' + _devotionalModule2.default.medium,
	        type: 'p'
	      }),
	      _react2.default.createElement(SkeletonElement, {
	        className: _devotionalModule2.default.paragraphSkeleton + ' ' + _devotionalModule2.default.long,
	        type: 'p'
	      }),
	      _react2.default.createElement(SkeletonElement, {
	        className: _devotionalModule2.default.paragraphSkeleton + ' ' + _devotionalModule2.default.medium,
	        type: 'p'
	      }),
	      _react2.default.createElement(SkeletonElement, {
	        className: _devotionalModule2.default.paragraphSkeleton + ' ' + _devotionalModule2.default.short,
	        type: 'p'
	      }),
	      _react2.default.createElement(SkeletonElement, { className: '' + _devotionalModule2.default.subTitleSkeleton, type: 'h3' }),
	      _react2.default.createElement(SkeletonElement, {
	        className: _devotionalModule2.default.paragraphSkeleton + ' ' + _devotionalModule2.default.medium,
	        type: 'p'
	      }),
	      _react2.default.createElement(SkeletonElement, {
	        className: _devotionalModule2.default.paragraphSkeleton + ' ' + _devotionalModule2.default.medium,
	        type: 'p'
	      }),
	      _react2.default.createElement(SkeletonElement, {
	        className: _devotionalModule2.default.paragraphSkeleton + ' ' + _devotionalModule2.default.short,
	        type: 'p'
	      })
	    )
	  );
	};
	
	var DevotionalPageTemplate = exports.DevotionalPageTemplate = function (_React$Component) {
	  _inherits(DevotionalPageTemplate, _React$Component);
	
	  function DevotionalPageTemplate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DevotionalPageTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      passage: '',
	      text: '',
	      loading: true
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DevotionalPageTemplate.prototype.componentDidMount = function componentDidMount() {
	    this.fetchDevotionalText();
	  };
	
	  DevotionalPageTemplate.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.date !== prevProps.date) {
	      this.fetchDevotionalText();
	    }
	  };
	
	  DevotionalPageTemplate.prototype.fetchDevotionalText = function fetchDevotionalText() {
	    var _this2 = this;
	
	    if (!this.state.loading) {
	      this.setState({ loading: true });
	    }
	
	    fetch(this.props.passagesUrl).then(function (response) {
	      return response.json();
	    }).then(function (passages) {
	      var date = _this2.props.date;
	
	      var passagesForCurrentMonth = passages[date.getMonth()];
	      var passage = passagesForCurrentMonth[date.getDate() - 1];
	
	      return _this2.queryAPI('html/?q=' + passage + '&include-passage-references=false').then(function (_ref2) {
	        var text = _ref2.passages;
	
	        _this2.setState({
	          passage: passage,
	          text: text
	        });
	      });
	    }).catch(function (error) {
	      return console.warn('Error', error.message);
	    }).finally(function () {
	      return _this2.setState({ loading: false });
	    });
	  };
	
	  DevotionalPageTemplate.prototype.queryAPI = function queryAPI(endpoint) {
	    var url = '' + ESV_API_URL + endpoint;
	    var options = {
	      headers: {
	        Authorization: 'Token ' + ESV_API_KEY
	      }
	    };
	
	    return fetch(url, options).then(function (response) {
	      return response.ok ? response.json() : Promise.reject(response);
	    });
	  };
	
	  DevotionalPageTemplate.prototype.render = function render() {
	    var options = {
	      year: 'numeric',
	      month: 'long',
	      day: 'numeric',
	      weekday: 'long'
	    };
	
	    var _state = this.state,
	        passage = _state.passage,
	        text = _state.text,
	        loading = _state.loading;
	    var date = this.props.date;
	
	
	    return _react2.default.createElement(
	      _Page2.default,
	      { title: 'Daily Devotion', className: _devotionalModule2.default.component },
	      _react2.default.createElement(_reactHelmet2.default, { title: this.props.title + ' | Daily Devotion' }),
	      loading ? _react2.default.createElement(SkeletonScreen, null) : _react2.default.createElement(
	        'article',
	        { className: _devotionalModule2.default.article },
	        _react2.default.createElement(
	          'div',
	          { className: _devotionalModule2.default.titleWrapper },
	          _react2.default.createElement(
	            'h2',
	            { className: _devotionalModule2.default.articleTitle },
	            passage
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              href: '' + ESV_AUDIO_URL + encodeURIComponent(passage) + '.mp3',
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              className: _devotionalModule2.default.audioLink
	            },
	            _react2.default.createElement(_headphones2.default, { className: _devotionalModule2.default.headphones })
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _devotionalModule2.default.date },
	          date.toLocaleDateString('en-US', options)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _devotionalModule2.default.articleContent },
	          _react2.default.createElement('div', {
	            className: _devotionalModule2.default.articleContent,
	            dangerouslySetInnerHTML: { __html: text }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _devotionalModule2.default.guideline },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Daily Devotion Guideline'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _devotionalModule2.default.articleContent },
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Start with a prayer asking God to speak to you through the passage.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Read today\u2019s passage until you are familiar with the story or the principal points of the text.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Try picking out a key verse of the passage and giving your own title to the text that in your opinion best summarizes the main point.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Try answering the question \u201CWho is God/Jesus like?\u201D from today\u2019s passage.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Prayerfully try to answer \u201CWhat lesson is God teaching me from today\u2019s devotion?\u201D'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'End with a prayer of thanksgiving and asking God \u201CHow can I apply today\u2019s teachings?\u201D'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _devotionalModule2.default.passageNav },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              rel: 'prev',
	              to: {
	                pathname: '/devotional/',
	                state: {
	                  date: new Date(date.getTime() - DAY)
	                }
	              }
	            },
	            '\u2190 Previous'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              rel: 'next',
	              to: {
	                pathname: '/devotional/',
	                state: {
	                  date: new Date(date.getTime() + DAY)
	                }
	              }
	            },
	            'Next \u2192'
	          )
	        )
	      )
	    );
	  };
	
	  return DevotionalPageTemplate;
	}(_react2.default.Component);
	
	DevotionalPageTemplate.defaultProps = {
	  date: new Date()
	};
	
	var DevotionalPage = function (_React$Component2) {
	  _inherits(DevotionalPage, _React$Component2);
	
	  function DevotionalPage() {
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, DevotionalPage);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this3), _this3.state = {
	      date: new Date()
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  DevotionalPage.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var currentState = this.props.location.state;
	    var prevState = prevProps.location.state;
	
	
	    if (currentState !== prevState) {
	      var date = currentState && currentState.date || new Date();
	      this.setState({ date: date });
	    }
	  };
	
	  DevotionalPage.prototype.render = function render() {
	    var page = this.props.data.markdownRemark;
	    var _page$frontmatter = page.frontmatter,
	        title = _page$frontmatter.title,
	        passagesUrl = _page$frontmatter.passagesUrl;
	    var date = this.state.date;
	
	
	    return _react2.default.createElement(DevotionalPageTemplate, {
	      title: title,
	      passagesUrl: passagesUrl,
	      date: date
	    });
	  };
	
	  return DevotionalPage;
	}(_react2.default.Component);
	
	DevotionalPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = DevotionalPage;
	var devotionalPageQuery = exports.devotionalPageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"article":"src-templates----devotional-module---article---Om5w_","articleTitle":"src-templates----devotional-module---articleTitle---3qBaq","articleTitleSkeleton":"src-templates----devotional-module---articleTitleSkeleton---f2eLS","articleContent":"src-templates----devotional-module---articleContent---ilhB1","subTitleSkeleton":"src-templates----devotional-module---subTitleSkeleton---3a9hF","paragraphSkeleton":"src-templates----devotional-module---paragraphSkeleton---3AHPE","long":"src-templates----devotional-module---long---2SsUl","medium":"src-templates----devotional-module---medium---35eit","short":"src-templates----devotional-module---short---2-TwV","date":"src-templates----devotional-module---date---gHS0a","passageNav":"src-templates----devotional-module---passageNav---2KYdc","headphones":"src-templates----devotional-module---headphones---BzbzC","audioLink":"src-templates----devotional-module---audioLink---2T8Wq","loading":"src-templates----devotional-module---loading---2nfou","guideline":"src-templates----devotional-module---guideline---algot"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-devotional-js-9d524f2e80b573a7cc02.js